// @flow

/**
 * better string building support
 */
class StringBuffer {

	constructor() {
		this.buffer = '';
	}

	prepend(str) {
		this.buffer = str + this.buffer;
		return this;
	}

	append(str) {
		this.buffer += str;
		return this;
	}

	reset() {
		this.buffer = '';
		return this;
	}

	toString() {
		return this.buffer;
	}

	getString() {
		return this.buffer;
	}
}

export default StringBuffer;



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/lib/StringBuffer.js